import {
  Dialog,
  Portal,
  CloseButton,
  Button,
  Flex,
  Separator,
} from "@chakra-ui/react";
import React, { PropsWithChildren, ReactNode } from "react";

interface BaseDialogProps extends PropsWithChildren {
  trigger: ReactNode;
  actionButtons?: ReactNode;
  title: string;
  open: boolean;
  setOpen: (open: boolean) => void;
}

const BaseDialog = ({
  trigger,
  children,
  title,
  actionButtons,
  open,
  setOpen,
}: BaseDialogProps) => {
  return (
    <Dialog.Root
      lazyMount
      open={open}
      onOpenChange={(e: { open: boolean }) => setOpen(e.open)}
    >
      <Dialog.Trigger>{trigger}</Dialog.Trigger>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content maxW={640} w="100%">
            <Dialog.Header>
              <Dialog.Title>{title}</Dialog.Title>
            </Dialog.Header>
            <Separator />
            <Dialog.Body p={6}>{children}</Dialog.Body>

            {actionButtons && (
              <>
                <Separator />
                <Dialog.Footer py={5}>
                  <Dialog.ActionTrigger>{actionButtons}</Dialog.ActionTrigger>
                </Dialog.Footer>
              </>
            )}

            <Dialog.CloseTrigger asChild>
              <CloseButton size="md" m={2} />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default BaseDialog;
